import {createMuiTheme} from '@material-ui/core/styles';

const primaryColor = '#1583C3';
const secondaryColor = '#FFFFFF';

export const theme = createMuiTheme({
    palette: {
      primary: {
        main: primaryColor,
        secondary: secondaryColor
      },
      secondary: {
        main: secondaryColor,
        secondary: primaryColor
      },
    },
  });